import axios from "axios"
import { configuration } from "."
import { msalInstance } from '../msalInstance';
import { loginRequest } from '../authConfig';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
export const api = axios.create({

  baseURL: configuration.API_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  },

})

// defining a custom error handler for all APIs
const errorHandler = (error) => {
  const statusCode = error.response?.status

  // logging only errors that are not 401
  // if (statusCode && statusCode !== 401) {
  //   console.error(error)
  // }

  return Promise.reject(error)
}

api.interceptors.request.use(
  async (config) => {
    try {
      // Ensure MSAL is initialized before making calls
      await msalInstance.initialize();
      
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        const response = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        config.headers.Authorization = `Bearer ${response.accessToken}`;
      }
    } catch (error) {
      console.error("Error acquiring token:", error);
      // If token acquisition fails, the request will proceed without auth header
      // The 401 response interceptor will handle it
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// registering the custom error handler to the
// "api" axios instance
api.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Handle 401 Unauthorized errors
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Ensure MSAL is initialized
        await msalInstance.initialize();
        
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          // Try to acquire token interactively
          const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
            forceRefresh: true
          });
          
          // Update the authorization header and retry the request
          originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;
          return api(originalRequest);
        } else {
          // No accounts available, redirect to login
          console.warn("No accounts found, redirecting to login");
          window.location.href = '/';
        }
      } catch (tokenError) {
        // Token refresh failed, redirect to login
        if (tokenError instanceof InteractionRequiredAuthError) {
          console.warn("Interactive login required");
          sessionStorage.clear();
          window.location.href = '/';
        }
      }
    }
    
    return errorHandler(error);
  }
)
